/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as errors from "../../../../errors/index.js";
import * as core from "../../../../core/index.js";

export class AccessDeniedError extends errors.LangfuseAPIError {
  constructor(body?: unknown, rawResponse?: core.RawResponse) {
    super({
      message: "AccessDeniedError",
      statusCode: 403,
      body: body,
      rawResponse: rawResponse,
    });
    Object.setPrototypeOf(this, AccessDeniedError.prototype);
  }
}
